<template>
  <dl class="warning-flag" :class="{ active, [flagType]: flagType }" v-if="list.length > 0">
    <dt @click="clicked()" :style="`--bg: url(/images/warning/flag_${flagType}_${flagLevel}.png)`">
      <div class="count" v-if="list.length > 1">{{ list.length }}</div>
      <img class="flag" :src="icon" />
    </dt>
    <dd v-if="list.length > 1">
      <ul>
        <li v-for="v in list">
          <img @click="clicked(v)" :src="getIcon(v)" />
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script>
import { GetWarningIcon } from '../constants';

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    clickCallback: {
      type: Function,
      default: null,
    },
    selectedCallback: {
      type: Function,
      default: null,
    },
    vm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      active: false, // 是否被选中以展开子级预警列表
    };
  },
  computed: {
    icon() {
      let self = this;
      let src = null;
      if (self.list.length > 0) {
        src = self.getIcon(self.list[0]);
      }
      return src;
    },
    flagType() {
      let self = this;
      let type = null;
      if (self.list.length > 0) {
        type = self.list[0].type;
      }
      return type;
    },
    flagLevel() {
      let self = this;
      let levelCode = '';
      if (self.list.length > 0) {
        levelCode = self.list[0].level;
      }
      levelCode = ('' + levelCode).padStart(3, '0');
      return levelCode;
    },
  },
  watch: {
    // active(v) {
    //   let self = this;
    // },
  },
  methods: {
    clicked(item = null) {
      let self = this;
      let target = item;
      // 点击某项
      if (item == null) {
        self.active = !self.active;
      }
      // 回传展示折叠事件
      typeof self.selectedCallback == 'function' && self.selectedCallback({ active: self.active, target: item || self.list[0] });
      // 回传点击预警的事件
      if (item == null) {
        if (self.list.length == 1) {
          target = self.list[0];
          setTimeout(() => {
            self.active = false; // 只有一项时不上弹（上弹变大用于展开子级，没有子级就不上弹变大了）
          }, 200);
        } else {
          return;
        }
      }
      typeof self.clickCallback == 'function' && self.clickCallback({ ...target });
    },
    blur() {
      let self = this;
      self.active = false;
    },
    getIcon(warning) {
      let src = null;
      const type = warning.type;
      const level = warning.level || '';
      const category = warning.category || '';
      // 收割热力:thermodynamic,收割进度:progression,天气weather
      src = GetWarningIcon(type, level, category);
      // console.log('getIcon', { type, level, src });
      return src;
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
dl.warning-flag {
  pointer-events: none;
  position: relative;
  z-index: 1;
  user-select: none;
  width: 0;
  height: 0;
  &.weather {
    dt {
      width: vw(45);
      height: vh(63);
      .flag {
        width: vw(36);
        height: vh(27);
        display: block;
        left: vw(4);
        top: vh(4);
      }
    }
    dd {
      bottom: vh(80);
    }
  }
  &.thermodynamic {
    dt {
      width: vw(36);
      height: vh(49);
    }
    dd {
      bottom: vh(63);
    }
  }
  &.progression {
    dt {
      width: vw(38);
      height: vh(44);
    }
    dd {
      bottom: vh(53);
    }
  }
  dt {
    pointer-events: all;
    background-image: var(--bg);
    background-size: 100% 100%;
    position: relative;
    transform: translate(-50%, -100%);
    cursor: pointer;
    &:hover {
      .flag {
        opacity: 0.9;
      }
    }
    .flag {
      position: absolute;
      display: none;
    }
    .count {
      pointer-events: none;
      position: absolute;
      left: 50%;
      bottom: 100%;
      transform: translateX(-50%);
      font-size: fontSize(12);
      color: #fff;
      line-height: 1.5;
      padding: 0 0.5em;
      background-color: rgba(0, 0, 0, 0.3);
      backdrop-filter: blur(1px);
      display: block;
      border-radius: 5px;
    }
  }
  dd {
    position: absolute;
    left: 50%;
    bottom: vh(77);
    transform: translateX(-50%);
    display: flex;
    height: 0;
    overflow: hidden;
    transition: height 0.1s ease-in-out;
    &::before,
    &::after {
      flex: 1;
      content: '';
      display: block;
      height: 100%;
      width: 50%;
      position: absolute;
      top: 0;
      bottom: 0;
      background: url(../images/bg_map_yj_list.png) no-repeat;
      background-size: cover;
    }
    &::before {
      left: 0;
      background-position: left bottom;
    }
    &::after {
      right: 0;
      background-position: right bottom;
    }
    ul {
      list-style: none;
      padding: vh(8) vw(15) 0;
      margin: 0;
      display: flex;
      gap: vw(8);
      position: relative;
      z-index: 1;
      &::after {
        content: '';
        background: url(../images/bg_map_yj_arrow.png) no-repeat;
        background-size: 100% 100%;
        display: block;
        width: vw(10);
        height: vh(9);
        position: absolute;
        left: 50%;
        bottom: vh(-6);
        transform: translateX(-50%);
      }
      li {
        padding: 0;
        margin: 0;
        width: vw(35);
        height: vh(26);
        text-align: center;
        font-size: 0;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        border-radius: 3px;
        &:hover {
          transform: translateY(-2px);
        }
        img {
          pointer-events: all;
          // width: 100%;
          height: 100%;
          display: block;
          margin: 0 auto;
          &:active {
            transform: translate(1px, 1px);
          }
        }
      }
    }
  }
  &.active {
    &.weather {
      dt {
        width: vw(54);
        height: vh(77);
        .flag {
          width: vw(42);
          height: vh(31);
          left: vw(6);
          top: vh(6);
        }
      }
    }
    &.thermodynamic {
      dt {
        width: vw(43);
        height: vh(59);
      }
    }
    &.progression {
      dt {
        width: vw(40);
        height: vh(50);
      }
    }
    dt {
      .count {
        display: none;
      }
    }
    dd {
      height: vh(41);
      overflow: visible;
    }
  }
}
dl,
dt,
dd {
  margin: 0;
  padding: 0;
}
</style>
